import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context";

/**
 * StoreEntry
 *
 * Route: /store
 *
 * Acts as the logical entry point for Zerobuild store projects.
 * - If the user is not logged in (no store currentUser), redirect to /login.
 * - If the user is logged in, redirect to /projects.
 *
 * This keeps the URL model described in the spec:
 *   /store -> /login (if new user) or /projects (if existing).
 */
const StoreEntry = () => {
  const navigate = useNavigate();
  const { currentUser } = useContext(AppContext);

  useEffect(() => {
    if (currentUser) {
      navigate(currentUser?.admin ? "/admin/dashboard" : "/projects", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [currentUser, navigate]);

  return null;
};

export default StoreEntry;


